import i18n from './i18n'

export const getDefinition = (c) => {
  return i18n.t(`universal.definitions.${c}`)
}
